export default function tidsbegrensetHent(funksjon, ms = 120000) {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            reject(new Error('Tidsbegrensning oversteget'))
        }, ms)
        funksjon.then(resolve, reject)
    })
}
